<template>
    <div>
        <h4 class="mb-2">Personal Information</h4>
        <div class="row">
            <fieldset class="col-lg-6">
                <input id="input-firstname" class="form-control" type="text" placeholder="First name" required 
                v-model="first_name" :readonly="readonly" 
                :class="{'is-invalid' : invalid.includes('first_name')}"/>
                <label for="input-firstname" class="form-label">First Name</label>
            </fieldset>
            
            <fieldset class="col-lg-6">
                <input id="input-lastname" class="form-control" type="text" placeholder="Last name" required 
                v-model="last_name" :readonly="readonly" 
                :class="{'is-invalid' : invalid.includes('last_name')}"/>
                <label for="input-lastname" class="form-label">Last Name</label>
            </fieldset>
        </div>

        <input id="input-address" class="form-control" type="text" placeholder="Address" 
        v-model="address" :readonly="readonly"
        :class="{'is-invalid' : invalid.includes('address')}"/>
        <label for="input-address" class="form-label">Address</label>
        
        <input id="input-city" class="form-control" type="text" placeholder="City" 
        v-model="city" :readonly="readonly" 
        :class="{'is-invalid' : invalid.includes('city')}"/>
        <label for="input-city" class="form-label">City</label>

        <div class="row">
            <fieldset class="col-md-8">
                <form-state v-model="state" :disabled="readonly" id="input-state"
                :class="{'is-invalid' : invalid.includes('state')}"></form-state>
                <label for="input-state" class="form-label">State</label>
            </fieldset>
        
            <fieldset class="col-md-4">
                <input id="input-zip" name="zip" class="form-control" type="text" placeholder="Zip code" pattern="[0-9]{5}" 
                v-model="zip" :readonly="readonly" 
                :class="{'is-invalid' : invalid.includes('zip')}"/> 
                <label for="input-zip" class="form-label">Zip Code</label>
            </fieldset>
        </div>
        
        <input id="input-email" name="email" class="form-control" type="email" placeholder="Email" required 
        v-model="email" :readonly="readonly || emailRo" 
        :class="{'is-invalid' : invalid.includes('email')}"/>
        <label for="input-email" class="form-label">Email</label>

        <input v-if="verifyEmail" id="input-confirm-email" name="email_confirm" class="form-control" type="email" placeholder="Email" required 
        :readonly="readonly || emailRo" 
        :class="{'is-invalid' : invalid.includes('verify_email')}"/>
        <label v-if="verifyEmail" for="input-confirm-email" class="form-label">Confirm Email</label>
    
        <form-telephone v-model="phone" :readonly="readonly" id="input-phone"
        :class="{'is-invalid' : invalid.includes('phone')}">
        </form-telephone>
        <label for="input-phone" class="form-label">Phone</label>

    </div>
</template>

<script>
import FormTelephone from './FormTelephone.vue';
import FormState from './FormState.vue';

export default {
    components: { FormTelephone, FormState },

    props: {
        readonly: {
            type: Boolean,
            default: false
        },

        verifyEmail: {
            type: Boolean,
            default: false
        },

        emailRo: {
            type: Boolean,
            default: false,
        },

        invalid: {
            type: Array,
            default(data=[]) {
                return [];
            },
        },

        value: {
            type: Object,
            required: true,
            default(data={}) {
                return data;
            }
        }
    },

    watch: {
        value: function(n, o) {
            this.first_name = n.first_name ?? '';
            this.last_name = n.last_name ?? '';
            this.address = n.address ?? '';
            this.city = n.city ?? '';
            this.state = n.state  ?? 'OH';
            this.zip = n.zip ?? '';
            this.email = n.email ?? '';
            this.phone = n.phone ?? '';
            this.grade_level = n.grade_level ?? '';
        },
    },

    updated() {
        const data = {
            first_name: this.first_name,
            last_name: this.last_name,
            address: this.address,
            city: this.city,
            state: this.state,
            zip: this.zip,
            email: this.email,
            phone: this.phone,
            // event_id: this.event_id,
            grade_level: this.grade_level,
        };

        this.$emit('input', data);      
    },

    data() {
        return {
            first_name: this.value.first_name,
            last_name: this.value.last_name,
            address: this.value.address,
            city: this.value.city,
            state: this.value.state,
            zip: this.value.zip,
            email: this.value.email,
            phone: this.value.phone,
            grade_level: this.value.grade_level,
        }
    },
}
</script>